<template>
  <div :class="{ content: !$ui.tight_mode, content_tight: $ui.tight_mode }">
    <slot />
  </div>
</template>
